import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import StyledNetworkItem from '../styles'

const CoinGecko: React.FC = () => (
  <StyledNetworkItem href="https://coingecko.com/en/exchanges/nomiswap" target="_blank" rel="noreferrer noopener">
    <SlIcon library="social" name="coingecko" />
  </StyledNetworkItem>
)
export default CoinGecko
